import React, { useEffect, useRef } from "react";

const SubtleTrailingCursorGlow = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = document.createElement("canvas");
    canvas.style.position = "fixed";
    canvas.style.top = "0";
    canvas.style.left = "0";
    canvas.style.pointerEvents = "none";
    canvas.style.zIndex = "9999";
    document.body.appendChild(canvas);
    canvasRef.current = canvas;

    const ctx = canvas.getContext("2d");

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    const trailCount = 10;
    const positions = Array(trailCount).fill(null).map(() => ({ x: 0, y: 0 }));

    let mousePos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    let isMoving = false;
    let isLooping = false;
    let mouseTimer;

    const lerp = (a, b, t) => a + (b - a) * t;

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      positions[0].x = mousePos.x;
      positions[0].y = mousePos.y;
      for (let i = 1; i < trailCount; i++) {
        positions[i].x = lerp(positions[i].x, positions[i - 1].x, 0.2);
        positions[i].y = lerp(positions[i].y, positions[i - 1].y, 0.2);
      }

      for (let i = 0; i < trailCount - 1; i++) {
        ctx.strokeStyle = `rgba(0,208,189,${(trailCount - i) / trailCount})`;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(positions[i].x, positions[i].y);
        ctx.lineTo(positions[i + 1].x, positions[i + 1].y);
        ctx.stroke();
      }

      if (isMoving) {
        requestAnimationFrame(animate);
      } else {
        // Clear completely on stop
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        isLooping = false;
      }
    };

    const handleMouseMove = (e) => {
      mousePos.x = e.clientX;
      mousePos.y = e.clientY;

      if (!isMoving) {
        isMoving = true;
        if (!isLooping) {
          isLooping = true;
          requestAnimationFrame(animate);
        }
      }

      clearTimeout(mouseTimer);
      mouseTimer = setTimeout(() => {
        isMoving = false;
      }, 100);
    };

    const handleMouseLeave = () => {
      isMoving = false;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseleave", handleMouseLeave);
      window.removeEventListener("resize", resizeCanvas);
      clearTimeout(mouseTimer);
      canvas.remove();
    };
  }, []);

  return null;
};

export default SubtleTrailingCursorGlow;
